import React, { FC } from 'react'
import ReactPlayer from 'react-player'

import {
  IForm_File,
} from '@kaidam/fc-shared/src/types/schema/form'

import {
  isVideo,
} from '@kaidam/fc-shared/src/utils/file'

import useFileUrl from '../hooks/useFileUrl'

interface UploadedVideoProps {
  file?: IForm_File,
  width?: string,
  height?: string,
}

const UploadedVideo: FC<React.PropsWithChildren<UploadedVideoProps>> = ({
  file,
  width = '120px',
  height = '80px',
}) => {
  const url = useFileUrl(file)
  if(!file) return null
  if(!url) return null
  if(!isVideo(file)) return null

  return (
    <ReactPlayer
      playing
      loop
      url={ url }
      width={ width }
      height={ height }
    />
  )
}

export default UploadedVideo